// extracted by mini-css-extract-plugin
export default {"clrBorder":"#ccc","root":"FormButtons_root__WFtJc","topMargin":"FormButtons_topMargin__AY0EK"};